// Products shown on category pages (by navigation slug)
export const preWeddingProducts = [
  {
    id: 43,
    title: 'Elegant Golden & White Proposal Decor',
    price: 6999,
    image: '/images/Special/Gemini_Generated_Image_umifhmumifhmumif.webp'
  },
  {
    id: 44,
    title: 'Romantic Rose Gold Pre-Wedding Decor',
    price: 6499,
    image: '/images/ThemeImages/proposal_copy.webp'
  },
  {
    id: 45,
    title: 'The Naming Nook Ring Decor',
    price: 5399,
    image: '/images/Special/Gemini_Generated_Image_y6hvrry6hvrry6hv.webp'
  },
  {
    id: 46,
    title: 'Royal Rapunzel Ring Decor',
    price: 6699,
    image: '/images/Special/Gemini_Generated_Image_nhw5c7nhw5c7nhw5.webp'
  },
  {
    id: 47,
    title: 'Princess Theme Ring Balloon Decor',
    price: 6599,
    image: '/images/Special/Gemini_Generated_Image_281mar281mar281m.webp'
  },
  {
    id: 48,
    title: 'Royal White & Golden Engagement Decor',
    price: 3199,
    image: '/images/FeaturedCollection/img_372.webp'
  },
  {
    id: 49,
    title: 'Romantic Red & White Pre-Wedding Setup',
    price: 1999,
    image: '/images/FeaturedCollection/img_368.webp'
  },
  {
    id: 50,
    title: 'Wedding Theme Balloon Arch Decor',
    price: 5899,
    image: '/images/ThemeImages/Wedding_c9b5e0ff-95cc-41c3-a745-8134a144d3cc.webp'
  }
];

export const kidsBirthdayProducts = [
  {
    id: 51,
    title: '1st Birthday Balloon Decor with Golden Stars',
    price: 2299,
    originalPrice: 2530,
    image: '/images/NewArrivals/img_118.webp'
  },
  {
    id: 52,
    title: 'Candyland Birthday Balloon Decor',
    price: 3599,
    originalPrice: 3899,
    image: '/images/NewArrivals/IMG1_286.webp'
  },
  {
    id: 53,
    title: 'Astronaut & Rocket Space Birthday Decor',
    price: 3799,
    image: '/images/NewArrivals/img_381.webp'
  },
  {
    id: 54,
    title: 'Hello Kitty Birthday Balloon Decor',
    price: 5699,
    image: '/images/Special/Gemini_Generated_Image_wpu8d9wpu8d9wpu8.webp'
  },
  {
    id: 55,
    title: '18th Birthday Black & Silver Decor with Bottle Arch',
    price: 2599,
    originalPrice: 2860,
    image: '/images/NewArrivals/img_448.webp'
  },
  {
    id: 56,
    title: 'Rainbow Theme Birthday Decor',
    price: 2299,
    originalPrice: 2530,
    image: '/images/FeaturedCollection/img_375.webp'
  },
  {
    id: 57,
    title: 'Rainbow Birthday Decor',
    price: 2199,
    originalPrice: 2420,
    image: '/images/FeaturedCollection/img_133.webp'
  },
  {
    id: 58,
    title: 'Kids Theme Party Balloon Decor',
    price: 4499,
    image: '/images/ThemeImages/kids_theme_copy.webp'
  },
  {
    id: 59,
    title: 'Pink & Golden Kids Birthday Decor',
    price: 2399,
    originalPrice: 2640,
    image: '/images/FeaturedCollection/Happy_Birthday_13.webp'
  },
  {
    id: 60,
    title: 'Rose Gold & Pink Birthday Balloon Arch Decor',
    price: 2499,
    image: '/images/FeaturedCollection/img_369.webp'
  }
];

// Map navigation slugs to dedicated product lists
export const categoryProductMap = {
  'pre-wedding-decoration': preWeddingProducts,
  'kids-birthday-decoration': kidsBirthdayProducts
};
